<template>
  <div class="inputBox">
    <el-input
      v-model="inputValue"
      style="width: 271px"
      :placeholder="props.placeholder"
      @keyup.enter="btn1Click"
    />
    <el-button type="primary" class="box1" @click="btn1Click">{{
      props.searchText1
    }}</el-button>
    <el-button type="primary" class="box2" @click="fn">{{
      props.searchText2
    }}</el-button>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const inputValue = defineModel("inputValue");
const emits = defineEmits(["query"]);
const props = defineProps({
  placeholder: {
    type: String,
    default: "请输入关键字",
  },
  searchText1: {
    type: String,
    default: "搜索",
  },
  searchText2: {
    type: String,
    default: "高级搜索",
  },
  path: {
    type: String,
    default: "",
  },
});

// 站内搜索
function btn1Click() {
  // 1表示站内搜索
  emits("query", 1, inputValue.value);
}

// 高级搜索
function fn() {
  router.push({
    path: props.path,
  });
}
</script>

<style scoped lang="scss">


//////输入框区域
.inputBox {
  width: 343px;
  //   height: 100px;
  //   border: 1px solid red;
  //   background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  //////输入框
  :deep(.el-input) {
    width: 271px !important;
    height: 34px;
    border-radius: 8px 0px 0px 8px !important;
    // border: 1px solid blue;
  }
  /////输入框边框
  :deep(.el-input__wrapper) {
    // border:1px solid blue;
    border-radius: 8px 0px 0px 8px !important;
  }
  //////两个按钮
  :deep(.el-button.el-button--primary) {
    // border:1px solid rgb(255, 0, 0);
    height: 34px;
    > span {
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
    }
  }
  //////第一个按钮
  :deep(.el-button.el-button--primary.box1) {
    // border:1px solid rgb(17, 255, 0);
    width: 72px;
    border-radius: 0px 8px 8px 0px;
  }
  //////第二个按钮
  :deep(.el-button.el-button--primary.box2) {
    // border:1px solid rgb(17, 255, 0);
    width: 72px;
    border-radius: 8px;
  }
}
</style>
